<template>
    <b-modal
        body-class="p-0"
        cancel-disabled
        hide-footer
        id="cancel-booking-modal"
        ok-disabled
        title="">
        <div class="modal-body modal-body-lg pt-0">
            <!-- Initial screen -->
            <empty-state
                v-if="!cancelling && !cancelled && !cancellationProcessing"
                class="pt-0"
                statusIcon="warning"
                :title="$t('bp.CancelBookingModal.confirmationMessage')"
            >
                <slot>
                    <button class="btn btn-danger btn-lg mb-4" @click="cancelBooking()" v-if="!loading && !cancelling">{{ $t('bp.CancelBookingModal.cancelYes') }}</button>
                    <button class="btn btn-link btn-block" @click="$bvModal.hide('cancel-booking-modal')">{{ $t('bp.CancelBookingModal.cancelNo') }}</button>
                </slot>
            </empty-state>

            <!-- Confirm cancellation -->
            <div class="text-center" v-if="cancelling && !cancelled && !cancellationProcessing">
                <div class="alert alert-danger" v-if="error">
                    <animated-error size="md" class="mr-2"></animated-error>
                    <div class="alert-content">
                        {{ $t('bp.CancelBookingModal.errorMessage') }}
                    </div>
                </div>
                <div class="form-group">
                    <h4 class="mb-3">{{ $t('bp.CancelBookingModal.cancelConfirm') }}</h4>
                    <input type="text" class="form-control" v-model="cancelConfirm">
                </div>
                <button class="btn btn-danger btn-lg mb-4" @click="confirmCancellation">{{ $t('bp.CancelBookingModal.cancelConfirmMessage') }}</button>
                <button class="btn btn-link btn-block" @click="cancelCancellation">{{ $t('bp.CancelBookingModal.cancelNo') }}</button>
            </div>

            <template v-if="cancellationProcessing">
                <loading-state></loading-state>
                <h4 class="mb-4 text-center">{{ $t('bp.CancelBookingModal.cancelling') }}</h4>
            </template>

        </div>
    </b-modal>
</template>

<script>
import {mapActions, mapGetters} from "vuex"

    export default {
        props:["order"],

        data() {
            return {
                cancelConfirm: null,
                cancelled: false,
                cancelling: false,
                cancellationProcessing: false,
                error: false,
                loading: false
            };
        },

        computed: {
            ...mapGetters(["countryCodeSetting"]),
        },

        methods: {
            ...mapActions([
                "cancelOrder",
                "displayToast"
            ]),

            /** When the user selects "Yes, cancel my booking" */
            cancelBooking() {
                this.cancelling = true;
                this.error = null;
            },

            /** Cancel the cancellation */
            cancelCancellation() {
                this.cancelling = false;
                this.error = null;
            },

            /** Cancel the order */
            confirmCancellation() {
                this.cancelling = false;
                this.error = false;

                if (!this.cancelConfirm || (this.cancelConfirm.toUpperCase() !== "CANCEL-REPAIR" && this.cancelConfirm.toUpperCase() !== "REPARATUR-ABBRECHEN")) {
                    this.error = true;
                    this.cancelling = true;
                }

                if (this.cancelConfirm.toUpperCase() === "CANCEL-REPAIR" || this.cancelConfirm.toUpperCase() === "REPARATUR-ABBRECHEN") {
                    this.cancellationProcessing = true;
                    this.cancelOrder({
                        order: this.order
                    }).then(() => {
                        this.cancellationProcessing = false;
                        this.$bvModal.hide("cancel-booking-modal")
                        this.displayToast({text: this.$t('bp.Toast.bookingCancelled'), type: 'success'});
                        this.$emit("order-cancelled");
                    })
                }
            }
        }
    }
</script>

<style scoped>

</style>